import 'css-chunksrc/client/scenes/planzoneResourceToProject/resourceToProjectForm/resourceSelection/styles.scss';export default {
  "firstInput": "_firstInput_so79g_1",
  "form": "_form_so79g_7"
};